import styled from 'styled-components'
import { ReactNode } from 'react'
import { tokens } from '../../styles/tokens'

export const Field = styled.div`
  margin-bottom: 18px;
`

export const Label = styled.label`
  display: block;
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${tokens.purple200};
  font-weight: 500;
  margin-bottom: 7px;
`

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  background: white;
  border: 1px solid ${tokens.purple100};
  border-radius: 10px;
  font-size: 14px;
  font-family: 'DM Sans', sans-serif;
  color: ${tokens.purple900};
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-sizing: border-box;

  &::placeholder {
    color: ${tokens.purple200};
  }
  &:focus {
    border-color: ${tokens.purple400};
    box-shadow: 0 0 0 3px rgba(155, 107, 181, 0.1);
  }
`

export const Select = styled.select`
  width: 100%;
  padding: 10px 14px;
  background: white;
  border: 1px solid ${tokens.purple100};
  border-radius: 10px;
  font-size: 14px;
  font-family: 'DM Sans', sans-serif;
  color: ${tokens.purple900};
  outline: none;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-sizing: border-box;
  appearance: none;

  &:focus {
    border-color: ${tokens.purple400};
    box-shadow: 0 0 0 3px rgba(155, 107, 181, 0.1);
  }
`

export const Hint = styled.p`
  font-size: 11px;
  color: ${tokens.purple200};
  margin-top: 5px;
`

export const ErrorText = styled.p`
  font-size: 11px;
  color: #c0436a;
  margin-top: 5px;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`

interface FormFieldProps {
  label: string
  hint?: string
  error?: string
  children: ReactNode
}

export function FormField({ label, hint, error, children }: FormFieldProps) {
  return (
    <Field>
      <Label>{label}</Label>
      {children}
      {hint && !error && <Hint>{hint}</Hint>}
      {error && <ErrorText>{error}</ErrorText>}
    </Field>
  )
}
